import { action, createRequestActions, createRequestTypes } from 'client/core/actions'
import _ from 'underscore'

const METHODS = ['get', 'post', 'put', 'delete']

/*
    #Methods
        ACTION: action type
        action: Object who must be dispatched by the store
        actions: Requests objects (REQUEST, SUCCESS, FAILURE, CANCEL)
        types: Requests types (REQUEST, SUCCESS, FAILURE, CANCEL)
    #OPTIONS
        excludedMethods: ['get', 'post', 'put', 'delete']
        moreMethods: ['method1', 'method2']                //Adds methods to defaults
        overwrite: Boolean                                 //Overwrite defaults methods with 'moreMethods'
        TODO: moreTypes: ['step1', 'step2']                      //Adds types to defaults (['REQUEST', 'SUCCESS', ..., 'ADDED_STEP'])
*/

class RequestsActions {
    constructor(KEY, options = {}) {
        this.KEY = KEY
        this.options = options
        this.methods = _.reject(METHODS, (method) => options.excludedMethods && options.excludedMethods.indexOf(method.toLowerCase()) !== -1)
        if (options.moreMethods && !options.overwrite)
            this.methods = this.methods.concat(options.moreMethods)
        else if (options.moreMethods)
            this.methods = options.moreMethods
        this.initMethods()
    }

    initMethods() {
        this.methods.forEach((method) => {
            this[method] = this.initMethod(method)
        })
    }

    initMethod(method) {
        const result = {}
        result.ACTION = `${method.toUpperCase()}_${this.KEY}`
        result.TYPES = createRequestTypes(`${method.toUpperCase()}_${this.KEY}`, this.options.moreTypes)
        result.actions = createRequestActions(result.TYPES, this.options.moreTypes)
        result.action = (payload) => action(result.ACTION, payload)
        return result
    }
}

export default RequestsActions




// WEBPACK FOOTER //
// ./src/client/core/RequestsActions.js